/**
 * RepatriationSection Component
 *
 * Direct wrapper for Repatriation component (no extra collapse)
 * Maintains existing Repatriation functionality with its own collapse
 */

import React from "react";
import Repatriation from "../../Repatriation/Repatriation";

const RepatriationSection = ({
  repatration,
  repatrationdata,
  updateNew,
  isLocalExit,
  baseEndpoint,
  setRepatriationAmount,
  setRepatriationSaved,
  setSelectedRepatrationType,
  trigger,
  setTrigger,
  isPreviewMode = false,
}) => {
  return (
    <Repatriation
      repatration={repatration}
      repatrationdata={repatrationdata}
      updateNew={updateNew}
      isLocalExit={isLocalExit}
      baseEndpoint={baseEndpoint}
      setRepatriationAmount={setRepatriationAmount}
      setRepatriationSaved={setRepatriationSaved}
      setSelectedRepatrationType={setSelectedRepatrationType}
      trigger={trigger}
      setTrigger={setTrigger}
    />
  );
};

export default RepatriationSection;
